import { Inject, Injectable } from '@angular/core';

@Injectable()
export class NodeLoggerService {

    isLogActive: boolean = true; //Defines if the log is active or not
    logFilepath: string = "src/assets/log.txt"; //logfile

    constructor( @Inject('isNode') private isNode: boolean)
    { }

    AddLogWithTime(mex: string): void {

        if (this.isNode) {

            if (this.isLogActive == false) {
                return;
            }

            const fs = require('fs');

            var dateObj = new Date();
            var year = dateObj.getFullYear();
            var month = dateObj.getMonth() + 1;
            var day = dateObj.getDate();

            var hour = dateObj.getHours();   
            var minutes = dateObj.getMinutes();   
            var seconds = dateObj.getSeconds();   
            var milliseconds = dateObj.getMilliseconds();   

            var dateStr = day+"/"+month+"/"+year+" "+hour+":"+minutes+":"+seconds+":"+milliseconds;
            
            //Prepending date to message
            mex = dateStr + ": "+ mex+"\n";           

            fs.appendFile(
                'src/assets/log.txt', 
                mex, 
                'utf8', 
                function (err) {
                    if (err) {
                    // append failed
                    } else {
                    // done
                    }
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/node-logger.service.ts